import React, { Component } from 'react';
import { EventEmitter } from 'fbemitter';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Footer from '../../Components/Footer/Footer';
import auth from '../Authentication/Auth';
import FuelTruckList from './FuelTruckList';

// This is here until we allow users to select/create multiple fuel farms
import FuelTrucks from '../../Services/FuelTrucks';

const authEvents = new EventEmitter();

class FuelFarmPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fuelFarmId: null,
      fuelTrucks: [],
    };

    this.getFuelTrucks = this.getFuelTrucks.bind(this);
  }

  componentWillMount() {
    this.getFuelTrucks(this);
  }

  getFuelTrucks() {
    const trucks = FuelTrucks.get({ fboId: this.props.fboId }).then((trucks) => {
      this.setState({ fuelTrucks: trucks });
    });
  }

  handleToggle() {
    this.setState({ drawerOpen: !this.state.drawerOpen });
  }

  renderLoading() {
    return (
      <main className="page-content">
        <div className="normal-page-header">
          <h1 className="left">Fuel Farm {this.props.fboId}</h1>
          <div className="clear" />
        </div>
        <section>
          Loading Fuel Trucks.
        </section>
        <Footer />
      </main>
    );
  }

  renderFuelTrucks() {
    const createState = {
      fboId: this.props.fboId,
    };

    return (
      <main className="page-content">
        <div className="normal-page-header">
          <h1 className="left">Fuel Trucks</h1>
          <Link
            to={{ pathname:`/fueltrucks/create`, state: createState }}
            className="btn btn-medium btn-primary right"
            params={{ fboId: this.props.fboId }}>
            <span className="mobile">+</span>
            <span className="desktop">Add Fuel Truck</span>
          </Link>
          <div className="clear" />
        </div>
        <FuelTruckList fboId={this.props.fboId} fuelTrucks={this.state.fuelTrucks} />
        <Footer />
      </main>
    );
  }

  render() {
    return (
      <span>
        {this.state.fuelTrucks !== null ? (
          this.renderFuelTrucks()
        ) : (
          this.renderLoading()
        )}
      </span>
    );
  }
}


FuelFarmPage.propTypes = {
  fboId: PropTypes.number.isRequired,
};

export default FuelFarmPage;

// <article className="fuel-item">
//   <div className="fuel-item-content">
//     <div className="fuel-level-chart urgency4">
//       <div className="fuel-level" style={{height:'3%'}}>
//         <div className="fuel-level-label">3%</div>
//       </div>
//     </div>
//     <h4>Truck Name 4</h4>
//     <h5>100LL</h5>
//     <p>15 / 500 Gal Capacity</p>
//     <a href="#link-to-this-fuel-items-settings-page" className="fuel-item-settings">Settings</a>
//   </div>
// </article>



// WEBPACK FOOTER //
// ./src/Containers/FuelTrucks/FuelTrucksPage.js